import { type MouseEvent } from 'react'
import { NavLink, type NavLinkProps } from 'react-router-dom'
import { useGuardedNavigate } from '@/shared/lib/useGuardedNavigate'
import { useUnsavedChangesOptional } from '@/shared/lib/useUnsavedChanges'
import { Tooltip } from '@/shared/ui/Tooltip'

export const GuardedNavLink = ({ onClick, title, ...props }: NavLinkProps) => {
  const ctx = useUnsavedChangesOptional()
  const guardedNavigate = useGuardedNavigate()

  const link = (
    <NavLink
      {...props}
      onClick={(event) => {
        if (ctx?.isDirty) {
          event.preventDefault()
          event.stopPropagation()

          void guardedNavigate(props.to, { replace: true, state: props.state }).then((didNavigate) => {
            if (didNavigate) {
              onClick?.(event as unknown as MouseEvent<HTMLAnchorElement>)
            }
          })

          return
        }

        onClick?.(event as unknown as MouseEvent<HTMLAnchorElement>)
      }}
    />
  )
  if (typeof title !== 'string' || !title) return link
  return <Tooltip label={title}>{link}</Tooltip>
}
